// extracted by mini-css-extract-plugin
export default {"imgdiv":"_26337a7a41 _1678caaa00","img":"_58bc1b8cf1 b71e2b6a4c"};